import { createAsyncThunk } from '@reduxjs/toolkit';

import { SecondaryMarketService } from 'api';

import { PaginationParams } from 'models';

export const getBuyersCounteroffers = createAsyncThunk(
	'secondaryMarket/getBuyersCounteroffers',
	async (params?: PaginationParams) => {
		return await SecondaryMarketService.getBuyerCounteroffers(params);
	},
);
